// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1uHec","header":"ReportDetails_header__15WNK","title":"ReportDetails_title__2hxCP","left":"ReportDetails_left__3AcV4"};